import { BaseConnector } from './baseConnector';

class UserHearingRoleConnector extends BaseConnector {
  createUserHearingRole(hearingId, userHearingRole) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/userHearingRole`;
    return this.authPost(url, userHearingRole);
  }

  deleteUserHearingRole(hearingId, userHearingRoleId) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/userHearingRole/${userHearingRoleId}`;
    return this.authDelete(url);
  }
}

export { UserHearingRoleConnector };
